<template>
    <section style="min-height:600px">
           <div v-if="loading" class="d-flex flex-row justify-content-center loading_card" style="height:600px;align-items: center;">
            <div v-if="loading" class="loading_card_spinner">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3"
                    color="var(--primary-color)" />
            </div>
        </div>
        <div v-else class="container py-5">
   <div
        v-if="loading"
        class="d-flex flex-row justify-content-center"
        style="margin-top: 100px; margin-bottom: 200px"
      >
        <hollow-dots-spinner
          :animation-duration="1000"
          :dot-size="35"
          :dots-num="3"
          color="var(--primary-color)"
        />
      </div>
     <div v-else class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
    <!-- Repeat this card for each product -->
    <!-- يمكنك تكرار هذا العنصر مع تغيير التفاصيل حسب الحاجة -->
    <div  v-for="(item, index) in this.DBitems"
            :key="index" class="col">
      <div class="card product-card"   
      @click="$router.push({
        name: 'section',
        params: {
            storeName: $store.storeName,
            id: item.id,
            name: item.name,
            lang: $i18n.locale
        },
    });">
        <img :src="item.icon" class="card-img-top" alt="Black Amber">
        <div class="card-body">
        
   <p class="card-title">{{ item.name }} </p>

        </div>
      </div>
    </div>
    </div>
     <div class="d-flex flex-row justify-content-center mt-5">
            <nav aria-label="Page navigation example"  class="paginate_div">

          <b-pagination
            v-model="page"
            :total-rows="count"
            :per-page="pageSize"
            :prev-text="$t('prev')"
            :next-text="$t('next')"
            pills
            @change="handlePageChange"
          ></b-pagination>
          </nav>
        </div>
    <!-- بقية المنتجات ... (نفس التنسيق) -->
    <!-- يمكنك تكرار البطاقات حسب الحاجة -->
  </div>
<hr></section>
</template>

<script>
import { HalfCircleSpinner, HollowDotsSpinner } from "epic-spinners";

export default {
  components: {HollowDotsSpinner, HalfCircleSpinner },
  data() {
    return {
      DBitems: null,
      loading: false,

      page: 1,
      count: 0,
      pageSize: 12,
      langChange:""
      //pageSizes: [3, 6, 9],
    };
  },
  created() {
    this.loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/sections",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        }
      )
      .then((response) => {
        this.DBitems = response.data.data.sections;
        this.pageSize=response.data.meta.per_page;

        this.count = response.data.meta.total;
      })
      .then(() => {
        this.loading = false;
      });
      if(this.$i18n.locale=='ar')
      {
      document.title = this.$store.state.title_ar;
      document.getElementById("description_meta").content=this.$store.state.description_ar;
      document.getElementById("keywords_meta").content=this.$store.state.keyword_ar;
      }
      else{
        document.title = this.$store.state.title_en;
      document.getElementById("description_meta").content=this.$store.state.description_en;
      document.getElementById("keywords_meta").content=this.$store.state.keyword_en;
      }
  },
  watch: {
    langChange() {
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/sections?page=" +
            this.page,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.DBitems = response.data.data.sections;
          //this.count = response.data.meta.total;
        }).then(() => {
        this.loading = false;
      });
    },
  },
  updated() {
    this.langChange=this.$i18n.locale
    /*  this.axios
        .get(
          "http://192.168.1.16:8000/api/" +
            this.$store.storeName +
            "/sections?page=" +
            this.page,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.DBitems = response.data.data.sections;
          //this.count = response.data.meta.total;
        }).then(() => {
        this.loading = false;
      });*/
  },
  methods: {
    retrieveTutorials() {
      const params = this.page;

      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/sections?page=" +
            params,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.DBitems = response.data.data.sections;
          //this.count = response.data.meta.total;
        })
        .then(() => (this.loading = false));
      /*.catch((e) => {
          console.log(params);
          console.log(e);
        });*/
    },
    handlePageChange(value) {
      this.page = value;
      this.retrieveTutorials();
    },
  },
};
</script>